<template>
  <van-form @failed="onFailed" @submit="handleSubmit" :show-error="false">
    <van-row class="non-bottom"></van-row>
    <van-field v-model="exporter.beneficiaryCode" label="出口商编码" autosize clearable
               placeholder="请输入3-8位数字、字母组合的出口商编码" input-align="right" error-message-align="right"
               :rules="rules.beneficiaryCodeRule" class="van-field-border van-field-required"></van-field>

    <van-field v-model="exporter.nameChinese" label="名称(中)" autosize clearable
               placeholder="请输入出口商中文名称" input-align="right" error-message-align="right"
               :rules="rules.nameChineseRule" class="van-field-border van-field-required"></van-field>

    <van-field v-model="exporter.nameEnglish" label="名称(英)" autosize clearable
               placeholder="请输入出口商英文名称" input-align="right" error-message-align="right"
               :rules="rules.nameEnglishRule" class="van-field-border van-field-required"></van-field>

    <van-field v-model="exporter.addressChinese" label="地址(中)" autosize clearable
               placeholder="请输入出口商中文地址" input-align="right" error-message-align="right"
               :rules="rules.addressChineseRule" class="van-field-border van-field-required"></van-field>

    <van-field v-model="exporter.addressEnglish" label="地址(英)" autosize clearable
               placeholder="请输入出口商英文地址" input-align="right" error-message-align="right"
               :rules="rules.addressEnglishRule" class="van-field-border van-field-required"></van-field>

    <van-field v-model="exporter.phone" label="联系方式" autosize clearable
               placeholder="请输入联系方式" input-align="right" class="van-field-border"></van-field>

    <van-field v-model="exporter.email" label="Email" autosize clearable
               placeholder="请输入邮箱地址" input-align="right" error-message-align="right"
               :rules="rules.emailRule" class="van-field-border"></van-field>

    <van-field v-model="exporter.fax" label="传真" autosize clearable
               placeholder="请输入传真"
               input-align="right" class="van-field-border"></van-field>

    <van-row class="non-bottom"></van-row>

    <van-row class="result-footer">
      <van-button round block type="info" native-type="submit">保存</van-button>
    </van-row>

  </van-form>
</template>

<script>
import {noticeManager} from "@zhoujianhui/vip-core";
import ExporterCreationDto from "../dto/ExporterCreationDto";
import exporterService from "../service/exporter-service";

export default {
  name: "exporterAdd",
  data() {
    return {
      exporter: new ExporterCreationDto(),
      rules: ExporterCreationDto.getRules(),
      submitDataError: null
    }
  },
  methods: {
    onFailed(error) {
      this.submitDataError = error;
    },
    async handleSubmit() {
      const result = await exporterService.addExporter(this.exporter);
      if (result.isSuccess()){
        await this.$router.go(-1);
      }
      noticeManager.showMessage(result.msg, result.type);
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/origin-certificate/style/form-add";
</style>